import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;

  * {
    white-space: nowrap;
  }
`;

export const Label = styled.div`
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 1px;
`;

export const Component = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  overflow: hidden;
`;
export const ComponentKey = styled.div`
  text-transform: capitalize;
  font-weight: 600;
  width: 80px;
`;

export const ComponentValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 1px;
  flex: 1;
`;

export const ProfileType = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
`;

export const ProfileTypeLabel = styled.div`
  flex: 1;
`;
export const CallStat = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
`;

export const CallStatType = styled.div`
  width: 40px;
`;
export const CallStatValue = styled.div`
  flex: 1;
  font-weight: 600;
`;
export const CallStatPercent = styled.div`
  width: 70px;
  text-align: right;
`;

export const Footer = styled.div`
  white-space: break-spaces;
  color: var(--theme-neutral-400);
`;
